import PropTypes from 'prop-types';
import { useRBACStore } from '../stores/useRBACStore';

export function Can({
  privilege,
  privileges,
  privilegeMode = 'any',
  role,
  roles,
  children,
  fallback = null,
}) {
  // Ensure only one of roles or privileges is provided
  if ((role || roles?.length) && (privilege || privileges?.length)) {
    throw new Error(
      'Can: You should provide either roles or privileges, not both.'
    );
  }

  const hasPrivilege = useRBACStore((s) => s.hasPrivilege);
  const hasAnyPrivilege = useRBACStore((s) => s.hasAnyPrivilege);
  const hasAllPrivileges = useRBACStore((s) => s.hasAllPrivileges);
  const hasRole = useRBACStore((s) => s.hasRole);
  const hasAnyRole = useRBACStore((s) => s.hasAnyRole);

  let isAllowed = false;

  if (role) {
    isAllowed = hasRole(role);
  } else if (roles?.length) {
    isAllowed = hasAnyRole(roles);
  } else if (privilege) {
    isAllowed = hasPrivilege(privilege);
  } else if (privileges?.length) {
    isAllowed =
      privilegeMode === 'all'
        ? hasAllPrivileges(privileges)
        : hasAnyPrivilege(privileges);
  }

  return isAllowed ? children : fallback;
}

Can.propTypes = {
  privilege: PropTypes.string,
  privileges: PropTypes.arrayOf(PropTypes.string),
  privilegeMode: PropTypes.oneOf(['any', 'all']),
  role: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};
